import { render, staticRenderFns } from "./RegisterForm.vue?vue&type=template&id=4c95b5c9&"
import script from "./RegisterForm.vue?vue&type=script&lang=js&"
export * from "./RegisterForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports